'use strict';
angular.module("newspaperStandbyDraftRouterModule",[])
    .config(['$stateProvider',function($stateProvider) {
        $stateProvider.state("front.editctr.newspaper.standbyDraft",{
            url:"/standbyDraft?paperid&banmianid&starttime&untiltime&dieciid",
            views:{
                "main@front.editctr" : {
                    templateUrl:"./editingCenter/newspaper/standbyDraft/standbyDraft_tpl.html",
                    controller:'newspaperStandbyDraftCtrl'
                }
            }
        });
    }]);